import { render, staticRenderFns } from "./GloboGraphicsCenasDisponiveis.vue?vue&type=template&id=3c60d8fb&scoped=true"
import script from "./GloboGraphicsCenasDisponiveis.vue?vue&type=script&lang=js"
export * from "./GloboGraphicsCenasDisponiveis.vue?vue&type=script&lang=js"
import style0 from "./GloboGraphicsCenasDisponiveis.vue?vue&type=style&index=0&id=3c60d8fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c60d8fb",
  null
  
)

export default component.exports